<!-- <template>
  <b-dropdown right class="dropdown-cat">
    <template slot="button-content">
      <i class="icon-more"></i>
    </template>
    <b-dropdown-item href="javascript:;" @click="viewDetail(dataSource)">Xem trước</b-dropdown-item>
    <b-dropdown-item href="javascript:;" @click="handleReset(dataSource)">Làm mới</b-dropdown-item>
  </b-dropdown>
</template> -->
<template>
  <div class="dropdown show">
    <i class="icon-more" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

  <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
    <a class="dropdown-item item-dropdown" style="color: #8599b8;" @click="viewDetail(dataSource)" href="#">Xem trước</a>
    <a class="dropdown-item item-dropdown" style="color: #8599b8;" @click="handleReset(dataSource)" href="#">Làm mới</a>
  </ul>
</div>
</template>
<script>
  import { resetUserWorkQuestion, getQuestionsByCat, getQuestionListOfOtherOrThematic } from './../_api/'
  import { mapActions } from 'vuex'
  import { STORE_KEY, ID_MODAL_PREVIEW_EXERCISE, TYPE_EXERCISE_OTHER, TYPE_EXERCISE_NORMAL } from './../_store/constants'

  export default {
    name: 'DropdownCat',
    props: {
      dataSource: Object,
      type: Number
    },
    data () {
      return {
      }
    },
    methods: {
      ...mapActions(STORE_KEY, ['acSetQuestionPreviewInfo']),

      handleReset (val) {
        this.$emit('resetQuestions', true)
      },

      viewDetail (val) {
        if (!this.type || this.type === TYPE_EXERCISE_NORMAL) {
          this.getQuestionsByExerciseNormal(val)
        } else {
          this.getQuestionsByExerciseOther(val)
        }
      },

      getQuestionsByExerciseNormal (val) {
        getQuestionsByCat(val.bookId, val.bookIndexId)
          .then(res => {
            if(res && res.data && !res.errors) {
              return this.acSetQuestionPreviewInfo({category: val, questions: res.data})
            }
          })
          .then(() => {
            this.$bvModal.show(ID_MODAL_PREVIEW_EXERCISE)
          })
      },

      getQuestionsByExerciseOther (val) {
        let self = this
        getQuestionListOfOtherOrThematic(val.id).then(res => {
            if(res && res.data && !res.errors) {
              return self.acSetQuestionPreviewInfo({category: val, questions: res.data})
            }
          })
          .then(() => {
            self.$bvModal.show(ID_MODAL_PREVIEW_EXERCISE)
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
.item-dropdown:active {
  background: #ededed;;
}
</style>